import { Box, Typography } from "@mui/material"
import type { FC } from "react"
import { useShallow } from "zustand/shallow"

import { GoodsReceiptLotTestStatusIndicator } from "./GoodsReceiptLotTestStatusIndicator"

import type { GoodsReceiptPallet, GoodsReceiptPalletRow } from "@/graphql/codegen/graphql"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"
import { getUomName } from "@/utils/uom"

interface GoodsReceiptPalletLotNumbersCellProps {
  pallet?: GoodsReceiptPallet
  uomId?: string | null
  goodsReceiptPalletRow?: GoodsReceiptPalletRow
}

export const GoodsReceiptPalletLotNumbersCell: FC<GoodsReceiptPalletLotNumbersCellProps> = ({
  pallet,
  uomId: uomIdProp,
  goodsReceiptPalletRow: palletRowProp,
}) => {
  const units = useUnitOfMeasurementsStore(useShallow((s) => s.units))

  const palletRow = palletRowProp ?? pallet?.goodsReceiptPalletRow
  const uomId = uomIdProp ?? palletRow?.product?.packageUsWeightUom
  const uomName = units.length > 0 ? getUomName(units, uomId) : uomId

  if (!palletRow?.lots || palletRow.lots.length === 0) {
    return (
      <Box className='flex flex-col gap-1'>
        <Typography variant='body2' className='text-gray-500'>
          -
        </Typography>
      </Box>
    )
  }

  return (
    <Box className='flex flex-col gap-1'>
      {palletRow.lots.map((lot) => (
        <Box key={lot.goodsReceiptPalletRowLotId} className='flex items-center gap-1'>
          <GoodsReceiptLotTestStatusIndicator status={lot?.productTest?.status} />

          <Box className='flex flex-wrap items-center gap-1'>
            <Typography variant='body2'>{lot.lotNumber}</Typography>
            {lot.totalUom && (
              <Typography variant='body2'>
                ({lot.totalUom} {uomName})
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  )
}
